const RevulsivoIcon = ({ width, height }) => {
    const defaultWidth = 17;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? defaultWidth}
            height={height ?? defaultWidth}
            viewBox="0 0 36 36"
        >
            <path fill="#CE9E5D" d="M32 36v-2a6 6 0 0 0-6-6H10a6 6 0 0 0-6 6v2h28z" />
            <path fill="#FFF35F" d="M4.09 33c-.055.326-.09.659-.09 1v2h28v-2c0-.341-.035-.674-.09-1H4.09z" />
            <path fill="#CCD6DD" d="M4 34h28v1H4z" />
            <path
                fill="#A0041E"
                d="M32 13.656c0 3.59-6.268 6.5-14 6.5s-14-2.91-14-6.5s6.268-2.5 14-2.5s14-1.09 14 2.5z"
            />
            <path fill="#292F33" d="M14 27h8s-1.018 7-4 7s-4-7-4-7z" />
            <path
                fill="#D5AB88"
                d="M13.64 28.101c1.744 1.267 2.848 1.962 4.36 1.962c1.511 0 2.616-.696 4.36-1.962V24.29h-8.72v3.811z"
            />
            <path
                fill="#CC9B7A"
                d="M13.632 25.973c1.216 1.374 2.724 1.746 4.364 1.746c1.639 0 3.147-.372 4.364-1.746v-3.491h-8.728v3.491z"
            />
            <path
                fill="#D5AB88"
                d="M11.444 15.935c0 1.448-.734 2.622-1.639 2.622s-1.639-1.174-1.639-2.622s.734-2.623 1.639-2.623c.906.001 1.639 1.175 1.639 2.623zm16.389 0c0 1.448-.734 2.622-1.639 2.622s-1.639-1.174-1.639-2.622s.734-2.623 1.639-2.623c.906.001 1.639 1.175 1.639 2.623z"
            />
            <path
                fill="#D5AB88"
                d="M9.478 16.96c0-5.589 3.816-10.121 8.522-10.121s8.522 4.531 8.522 10.121c0 5.589-3.816 10.12-8.522 10.12s-8.522-4.531-8.522-10.12z"
            />
            <path
                fill="#C1694F"
                d="M18 23.802c-2.754 0-3.6-.706-3.741-.848a.655.655 0 0 1 .902-.951c.052.038.721.487 2.839.487c2.2 0 2.836-.485 2.842-.49a.64.64 0 0 1 .913.013a.671.671 0 0 1-.014.94c-.141.143-.987.849-3.741.849z"
            />
            <path
                fill="#963B22"
                d="M18 3.479c5.648 0 9.178 4.168 9.178 7.641s-.706 4.863-1.412 3.473l-1.412-2.778s-4.236 0-5.648-1.39c0 0 2.118 4.168-2.118 0c0 0 .706 2.779-3.53-.695c0 0-2.118 1.39-2.824 4.863c-.196.963-1.412 0-1.412-3.473S11.646 3.479 18 3.479z"
            />
            <path
                fill="#662113"
                d="M14 17c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1zm8 0c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1z"
            />
            <path
                fill="#C1694F"
                d="M18.75 19.75h-1.5c-.413 0-.75-.337-.75-.75s.337-.75.75-.75h1.5c.413 0 .75.337.75.75s-.337.75-.75.75z"
            />
            <path
                fill="#292F33"
                d="M27 36v-9c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v9h3zm-15 0v-9c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v9h3z"
            />
            <path
                fill="#DF1F32"
                d="M28.853 10.857c-.86-.173-1.093-4.028-3.084-6.859C23.894 1.335 20.304 0 17.997 0S12.1 1.335 10.226 3.998c-1.992 2.831-2.224 6.686-3.084 6.859c-3.317.665-3.161 2.386-3.14 2.782c.123-.466.438-1.578 3.902-1.64c3.404-.06 6.58.806 10.094.806s6.69-.866 10.094-.806c3.464.061 3.778 1.173 3.902 1.64c.02-.396.176-2.117-3.141-2.782z"
            />
            <path
                fill="#EA596E"
                d="M18 0c-2.094 0-5 3.593-5 5.054V9s.109 1 .92 1h8.16c.811 0 .92-1 .92-1V5.054C23 3.593 20.094 0 18 0z"
            />
            <path
                fill="#CE9E5D"
                d="M23.883 25c-.406-.378-2.474.364-3.019 1c-.545.636-.638 1.737-1.01 3c-.318 1.079-1.572 3.958-1.931 4.775c-.358-.817-1.605-3.696-1.923-4.775c-.372-1.263-.455-2.364-1-3s-2.594-1.378-3-1s.015 1.463 0 2s0 9 0 9h12s.015-8.463 0-9s.289-1.622-.117-2z"
            />
        </svg>
    );
};

export default RevulsivoIcon;
